var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    _vm._g(
      _vm._b(
        {
          ref: "observer",
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function ({ valid, invalid }) {
                  return [
                    _vm._t("default", null, {
                      preSubmit: _vm.preSubmit,
                      reset: _vm.reset,
                      valid: valid,
                      invalid: invalid,
                    }),
                  ]
                },
              },
            ],
            null,
            true
          ),
        },
        "validation-observer",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }